<div class="wrapper wrapper-content">
  <div class="p-review pointer" *ngIf="reviewList.length">
    <div
      class="ibox float-e-margins objectiveBox"
      *ngFor="let review of reviewList"
      [ngClass]="{
        'dark-theme':
          userInfo?.Theme.VariationCode === 'F' ||
          userInfo?.Theme.VariationCode === 'D',
        opacity_half: !review.Upcomind_date || !review.Last_change
      }"
    >
      <div class="ibox-content text-color" (click)="selectReview(review)">
        <div class="display-flex-space-between pointer">
          <div class="big review-title">{{ review.title }}</div>
        </div>

        <div class="display-flex-left bold">
          <div class="sub-part-1">
            <div class="description-detail">
              <div>
                <label>
                  {{ 'PERFORMANCE_REVIEW.PeriodUnderReview' | translate }}:
                </label>
                <p>{{ review.Period_under_Review }}</p>
              </div>
              <div>
                <label>
                  {{ 'PERFORMANCE_REVIEW.UpcomingDate' | translate }}:
                </label>
                <p *ngIf="!review.secondReviewer">
                  {{ 'PERFORMANCE_REVIEW.DeadlineForYourReviews' | translate }}
                  {{ review.Upcomind_date }}
                </p>
                <p *ngIf="review.secondReviewer">
                  {{
                    'PERFORMANCE_REVIEW.DeadlineForSecondReviewerReviews'
                      | translate
                  }}
                  {{ review.Upcomind_date }}
                </p>
              </div>
              <div>
                <label>
                  {{ 'PERFORMANCE_REVIEW.LastChange' | translate }}:
                </label>
                <p>{{ 'PERFORMANCE_REVIEW.ANew360HasStarted' | translate }}</p>
              </div>
            </div>
          </div>
          <div class="sub-part-3">
            {{ 'PERFORMANCE_REVIEW.ManagerReview' | translate }}
            <hr class="desktop-hr" />
            <div class="review-type">
              <label class="review-360">
                {{ 'PERFORMANCE_REVIEW.EmployeeReview' | translate }}
                <div class="piechart">
                  <div class="text">
                    64 {{ 'PERFORMANCE_REVIEW.Total' | translate }}
                  </div>
                  <div class="line-1"></div>
                  <div class="line-2"></div>
                </div>
              </label>
              <label class="review-360" *ngIf="review.secondReviewer">
                {{ 'PERFORMANCE_REVIEW.SecondReviewerReview' | translate }}
                <div class="piechart">
                  <div class="text">
                    64 {{ 'PERFORMANCE_REVIEW.Total' | translate }}
                  </div>
                  <div class="line-1"></div>
                  <div class="line-2"></div>
                </div>
              </label>
              <label class="manager-review">
                {{ 'PERFORMANCE_REVIEW.YourReview' | translate }}
                <button class="review-btn not-started btn">
                  {{ 'PERFORMANCE_REVIEW.NotStarted' | translate }}
                </button>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="p-review p-review-not" *ngIf="reviewList.length === 0">
    <!-- not data div -->
    <div class="setLogo-image">
      <img
        *ngIf="userInfo.Theme.Code === 'RB'"
        src="assets/images/PerformanceReview/PR1.png"
      />
      <img
        *ngIf="userInfo.Theme.Code === 'LG'"
        src="assets/images/PerformanceReview/PR2.png"
      />
      <img
        *ngIf="userInfo.Theme.Code === 'M'"
        src="assets/images/PerformanceReview/PR3.png"
      />
      <img
        *ngIf="userInfo.Theme.Code === 'S'"
        src="assets/images/PerformanceReview/PR4.png"
      />
      <img
        *ngIf="userInfo.Theme.Code === 'T'"
        src="assets/images/PerformanceReview/PR5.png"
      />
      <img
        *ngIf="userInfo.Theme.Code === 'SP'"
        src="assets/images/PerformanceReview/PR6.png"
      />
    </div>
    <div class="content-text">
      <p>{{ 'PERFORMANCE_REVIEW.NO_REVIEW' | translate }}</p>
    </div>
  </div>
</div>
<footer
  [the_Wall]="theWall"
  [toRefresh]="toRefresh"
  (refreshRequired)="reloadWall()"
></footer>
